import type { CanDeactivateFn } from '@angular/router';
import type { UnsavedChangesAware } from './unsaved-changes.types';

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (
    component,
) => component?.canDeactivate?.() ?? true;
